module.exports = __webpack_public_path__ + "img/未标题-3-10.340a4b5f.png";